import { render, staticRenderFns } from "./AddSuperuser.vue?vue&type=template&id=7f135f56&scoped=true&"
import script from "./AddSuperuser.vue?vue&type=script&lang=js&"
export * from "./AddSuperuser.vue?vue&type=script&lang=js&"
import style0 from "./AddSuperuser.vue?vue&type=style&index=0&id=7f135f56&prod&scoped=true&lang=scss&"


/* normalize component */
import normalizer from "!../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "7f135f56",
  null
  
)

export default component.exports